import { redirect } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { queryClient } from "@/lib/queryClient";
import { ALL_PROFILES_QUERY_KEY, USERS_STALE_TIME } from "@/lib/users-cache";
import { userService } from "@/services/UserService";
import UsersPage from "./Users";
import { BotDetectionSettings } from "@/components/settings/BotDetectionSettings";
import { MonitoringSettings } from "@/components/settings/MonitoringSettings";
import { VipTargetsSettings } from "@/components/settings/VipTargetsSettings";
import { AlertsSettings } from "@/components/settings/AlertsSettings";

// Admin settings: global Oracul configuration + team access, as tabs. Personal
// profile/security lives on /account now. Admin-only — same gate the old /users
// route used.
export async function settingsLoader() {
  const role = await userService.getCurrentUserRole();
  if (!role) return redirect("/login");
  if (role !== "admin") return redirect("/");

  await queryClient.prefetchQuery({
    queryKey: ALL_PROFILES_QUERY_KEY,
    queryFn: () => userService.fetchAllProfiles(),
    staleTime: USERS_STALE_TIME,
  });

  return null;
}

export default function SettingsPage() {
  return (
    <div className="space-y-6 p-8">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Settings</h1>
        <p className="text-muted-foreground">
          Team access and global Oracul settings.
        </p>
      </div>

      <Tabs defaultValue="members" className="space-y-4">
        <TabsList>
          <TabsTrigger value="members">Team Members</TabsTrigger>
          <TabsTrigger value="bots">Bot Detection</TabsTrigger>
          <TabsTrigger value="monitoring">Indexation &amp; DMCA</TabsTrigger>
          <TabsTrigger value="alerts">Alerts</TabsTrigger>
        </TabsList>

        <TabsContent value="members">
          <UsersPage />
        </TabsContent>

        <TabsContent value="bots">
          <BotDetectionSettings />
        </TabsContent>

        {/* One engine checks domains for both DMCA takedowns and index status,
            so its tiering + schedule live together here. */}
        <TabsContent value="monitoring">
          <div className="space-y-8">
            <MonitoringSettings />
            <VipTargetsSettings />
          </div>
        </TabsContent>

        <TabsContent value="alerts">
          <AlertsSettings />
        </TabsContent>
      </Tabs>
    </div>
  );
}
